import {
    PRIMARY_BUSINESS_LOCATION_CONTACT_PERSON,
    PRIMARY_BUSINESS_ADDRESS,
    ADDITIONAL_BUSINESS_LOCATION,
    SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyLicence/TDCLicence';
import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';

export const formatTDC = async (licenceDetails: any, caseTypeID: string, application?: string) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;
    let businessLocation = [];

    newDocs = [];
    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    if (licenceDetails && licenceDetails.BusinessLocation && licenceDetails.BusinessLocation.length > 0) {
        businessLocation = licenceDetails?.BusinessLocation.slice(1).map((value: any, i: number) => ({
            no: value?.SerialNumber ?? '-',
            'branch-name': value?.contactPersonParticulars?.branchName ?? '-',
            designation: value?.contactPersonParticulars?.designation ?? '-',
            'branch-contact-person': value?.contactPersonParticulars?.branchContactPerson ?? '-',
            'office-tel-number': value?.contactPersonParticulars.officeTelNumber ?? '-',
            'mobile-number': value?.contactPersonParticulars?.mobileNumber ?? '-',
            email: value?.contactPersonParticulars?.email ?? '-',
            address: value?.Location ?? '-'
        }));
    }

    licence = {
        id: 'telecommunication-dealers-class',
        formID: 'telecommunication-dealers-class',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Licence Details',
        values: {
            [`${PRIMARY_BUSINESS_LOCATION_CONTACT_PERSON}-name`]:
                licenceDetails?.BusinessLocation[0]?.contactPersonParticulars?.name ?? '-',
            [`${PRIMARY_BUSINESS_LOCATION_CONTACT_PERSON}-designation`]:
                licenceDetails?.BusinessLocation[0]?.contactPersonParticulars?.designation ?? '-',
            [`${PRIMARY_BUSINESS_LOCATION_CONTACT_PERSON}-email`]:
                licenceDetails?.BusinessLocation[0]?.contactPersonParticulars?.email ?? '-',
            [`${PRIMARY_BUSINESS_LOCATION_CONTACT_PERSON}-office-tel-number`]:
                licenceDetails?.BusinessLocation[0]?.contactPersonParticulars?.officeTelNumber ?? '-',
            [`${PRIMARY_BUSINESS_LOCATION_CONTACT_PERSON}-mobile-number`]:
                licenceDetails?.BusinessLocation[0]?.contactPersonParticulars?.mobileNumber ?? '-',

            [`${PRIMARY_BUSINESS_ADDRESS}-building-name`]: licenceDetails?.BusinessLocation[0]?.address?.buildingName ?? '-',
            [`${PRIMARY_BUSINESS_ADDRESS}-postal-code`]: licenceDetails?.BusinessLocation[0]?.address?.postalCode ?? '-',
            [`${PRIMARY_BUSINESS_ADDRESS}-street-name`]: licenceDetails?.BusinessLocation[0]?.address?.streetName ?? '-',
            [`${PRIMARY_BUSINESS_ADDRESS}-block-house-no`]: licenceDetails?.BusinessLocation[0]?.address?.blockNo ?? '-',
            [`${PRIMARY_BUSINESS_ADDRESS}-floor-level-optional`]: licenceDetails?.BusinessLocation[0]?.address?.floor ?? '-',
            [`${PRIMARY_BUSINESS_ADDRESS}-unit-optional`]: licenceDetails?.BusinessLocation[0]?.address?.unit ?? '-',

            [`${ADDITIONAL_BUSINESS_LOCATION}-list`]: businessLocation ?? [...businessLocation],

            [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
        }
    };

    return licence;
};

const tdcPayload = {
    formatTDC
};

export default tdcPayload;
